module.exports = __webpack_public_path__ + "img/ico-settings.26c2e26b.svg";